import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import "./styles/pages/themes.css";
import router from "./routes/routes";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/Reusable/ErrorFallback";
import { CompanyProvider } from "./context/CompanyProvider";
import { PermissionProvider } from "./context/PermissionContext";

function App() {
  return (
    <ThemeProvider>
      <CompanyProvider>
        <PermissionProvider>
          <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onReset={() => window.location.reload()}
          >
            <RouterProvider router={router} />
          </ErrorBoundary>
        </PermissionProvider>
      </CompanyProvider>
    </ThemeProvider>
  );
}

export default App;

